import type { LinkField } from '@tmh-website/shared/cms';

export const convertLinkFieldAttributesArrayToObject = (
  attributes: LinkField['attributes']
): Record<string, string> => {
  return (attributes || []).reduce((acc, attribute) => {
    acc[attribute.name] = attribute.value;

    return acc;
  }, {});
};
